import React from 'react'
import PropTypes from 'prop-types'
import { isMobile } from 'components/common/Media/helpers'
import MobileHeader from './components/MobileHeader'
import Stepper from 'components/common/Stepper'

const StepperHeader = ({ threeStepperEnabled, ...props }) => !threeStepperEnabled && isMobile()
  ? <MobileHeader threeStepperEnabled={ threeStepperEnabled } { ...props } />
  : <Stepper noLastStep={ threeStepperEnabled } { ...props } />

StepperHeader.propTypes = {
  threeStepperEnabled: PropTypes.bool
}

export default StepperHeader
